import React from 'react'
import Select from 'react-select';
import Accordion from 'react-bootstrap/Accordion';
const Gst = () => {
    const basicDutyOpt = [{ value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' },];
    const igstEXEMPTION = [{ value: 'GST No', label: 'GST No' },
    { value: 'Customer No', label: 'Customer No' },];
    const basicUnit = [
        { value: 'Plus', label: 'Plus' },
        { value: 'Minus', label: 'Minus' },
        { value: 'Higher', label: 'Higher' },
        { value: 'Lower', label: 'Lower' },
    ]
    return (
        <div className="card">
            <div className="card-body">

                <form>
                    <Accordion defaultActiveKey="0" className="accordion-item rounded mb-3" >
                        <Accordion.Item eventKey="0">
                            <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark"> <span className="avatar avatar-md rounded text-dark border me-2">
                                <i className="ti ti-user-plus fs-20" />
                            </span>
                                Pool Issue Price</Accordion.Header>
                            <Accordion.Body>
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            Notification & Sr. No.
                                        </label>

                                    </div>
                                    <div className="d-md-flex justify-content-start align-items-center gap-2">

                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                        />
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicDutyOpt}
                                        />
                                        <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                            defaultValue="0.00"
                                        />
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicDutyOpt}
                                        />

                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>

                    <Accordion defaultActiveKey="1" className="accordion-item rounded mb-3" >
                        <Accordion.Item eventKey="1">
                            <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark"> <span className="avatar avatar-md rounded text-dark border me-2">
                                <i className="ti ti-user-plus fs-20" />
                            </span>
                                IGST</Accordion.Header>
                            <Accordion.Body>
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            Duty
                                        </label>

                                    </div>
                                    <div className="d-md-flex justify-content-start align-items-center gap-2">

                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                        />
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicDutyOpt}
                                        />
                                        <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                            defaultValue="0.00"
                                        />
                                        <div>%</div>
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicUnit}
                                        />
                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                            defaultValue="0.00"
                                        />
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicDutyOpt}
                                        />
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-start gap-2 align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            Exemption
                                        </label>
                                        <Select
                                            className='custom-selector w-auto'
                                            options={igstEXEMPTION}
                                        />
                                    </div>
                                    <div className="d-md-flex justify-content-start align-items-center gap-2">

                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                        />
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicDutyOpt}
                                        />
                                        <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                            defaultValue="0.00"
                                        />
                                        <div>%</div>
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicUnit}
                                        />
                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                            defaultValue="0.00"
                                        />
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicDutyOpt}
                                        />
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            Effective Duty
                                        </label>

                                    </div>
                                    <div className="d-md-flex justify-content-start align-items-center gap-2">

                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                            defaultValue="0%"
                                        />

                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>


                    <Accordion defaultActiveKey="2" className="accordion-item rounded mb-3" >
                        <Accordion.Item eventKey="2">
                            <Accordion.Header className="accordion-header accordion-custom-button bg-white rounded fw-medium text-dark"> <span className="avatar avatar-md rounded text-dark border me-2">
                                <i className="ti ti-user-plus fs-20" />
                            </span>
                                Compensation CESS</Accordion.Header>
                            <Accordion.Body>
                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            Duty
                                        </label>

                                    </div>
                                    <div className="d-md-flex justify-content-start align-items-center gap-2">

                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                        />
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicDutyOpt}
                                        />
                                        <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                            defaultValue="0.00"
                                        />
                                        <div>%</div>
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicUnit}
                                        />
                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                            defaultValue="0.00"
                                        />
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicDutyOpt}
                                        />
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-start gap-2 align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            Exemption
                                        </label>
                                        <Select
                                            className='custom-selector w-auto'
                                            options={igstEXEMPTION}
                                        />
                                    </div>
                                    <div className="d-md-flex justify-content-start align-items-center gap-2">

                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                        />
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicDutyOpt}
                                        />
                                        <input type="checkbox" defaultChecked="checked" className="form-check-input" id="exampleCheck1" />
                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                            defaultValue="0.00"
                                        />
                                        <div>%</div>
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicUnit}
                                        />
                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                            defaultValue="0.00"
                                        />
                                        <Select
                                            className='custom-selector w-auto'
                                            options={basicDutyOpt}
                                        />
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <div className=" mb-1 d-flex justify-content-between align-items-center">
                                        <label htmlFor="name" className="form-label mb-0 text-label-red">
                                            Effective Duty
                                        </label>

                                    </div>
                                    <div className="d-md-flex justify-content-start align-items-center gap-2">

                                        <input
                                            type="text"
                                            className="form-control form-control-sm w-auto"
                                            id="name"
                                            name="name"
                                            defaultValue="0%"
                                        />

                                    </div>
                                </div>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>

                    <div className="row justify-content-end mt-3 gap-2">
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save & Close
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Save & New
                        </button>
                        <button className="btn btn-primary text-xs w-fit" type="submit" >
                            Close
                        </button>

                    </div>
                </form>
            </div>
        </div>
    )
}

export default Gst